import { Action, createReducer, on } from '@ngrx/store';
import { FilterPanelActions } from '../../actions';

export interface FilterPanelState {
  isOpen: boolean;
  currentFilterInstanceId: string;
}

const initialState: FilterPanelState = {
  isOpen: false,
  currentFilterInstanceId: null,
};

const reducer = createReducer(
  initialState,
  on(FilterPanelActions.init, (state, action) => {
    return {
      ...state,
      currentFilterInstanceId: action.filterInstanceId,
    };
  }),
  on(FilterPanelActions.open, (state) => {
    return {
      ...state,
      isOpen: true,
    };
  }),
  on(FilterPanelActions.close, (state, action) => {
    const newState = {
      ...state,
      isOpen: false,
    };

    if (action.destroy) {
      newState.currentFilterInstanceId = null;
    }

    return newState;
  })
);

export function filterPanelReducer(state = initialState, action: Action): FilterPanelState {
  return reducer(state, action);
}
